import { categoriesUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'
//
//Always get current restaurant from the store
//
async function getCategoriesByRestaurant() {

    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${categoriesUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.categories });
    return data;
}

async function getCategoriesByRestaurantId(id) {

    let restaurantid = id;
    let url = `${categoriesUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.categories });
    return data;
}

async function getCategoryById(categoryid) {
    let url = `${categoriesUrl}/${categoryid}`;
    await common.getDataWithToken(url)
                .then((response) => {
        return response.categories;
    });
}

async function createCategory(data) {
    let url = `${categoriesUrl}`;
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    return await common.postData(url, data)
                .catch(err => console.log(err));
}

async function updateCategory(data) {
    let url = `${categoriesUrl}/${data.categoryId}`;
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    await common.putData(url, data);
}

async function deleteCategory(categoryId) {
    let url = `${categoriesUrl}/${categoryId}`;
    await common.deleteData(url);
}

export default {
    name: 'categoriesService',
    getCategoriesByRestaurant,
    getCategoriesByRestaurantId,
    getCategoryById,
    createCategory,
    updateCategory,
    deleteCategory
}